import VanillaMask from 'vanilla-masker';

import {
    BUDGET_PROPOSAL_CREATE_REQUEST_FAIL,
    BUDGET_PROPOSAL_CREATE_REQUEST_SUCCESS,
    SELECT_PROPOSAL_BUDGET,
} from '../action.types';

import initialState from '../initial.state';

export default function (state = initialState.budgetProposal, action) {
    switch (action.type) {
        case BUDGET_PROPOSAL_CREATE_REQUEST_SUCCESS:
            return { ...action.payload };
        case BUDGET_PROPOSAL_CREATE_REQUEST_FAIL:
            return state;
        case SELECT_PROPOSAL_BUDGET:
            return action.proposal.id ? buildProposalObject(action.proposal) : action.proposal
        default:
            return state;
    }
}

const buildProposalObject = proposal => ({
    id: proposal.id,
    budgetId: proposal.budgetId,
    conditionsAndDetails: proposal.conditionsAndDetails,
    protocol: proposal.protocol,
    attachments: proposal.attachments,
    provider: {
        label: proposal.provider.fantasyName,
        value: proposal.provider.id
    },
    price: VanillaMask.toMoney(proposal.price, {
        precision: 2,
        separator: ',',
        delimiter: '.',
        unit: 'R$',
        zeroCents: true
    })
})



// WEBPACK FOOTER //
// ./src/redux/budget/proposal.reducer.js